/* fb-pdp-sub.js (Claude fixes 71, P21): product page size switch and subscription helpers. Main product only.
   1. Instant size switch: a tap on a size card updates the id, price, kr/kg, button, URL, stock and delivery rows (P7, via
      the fb:variant event that fb-buybox-trust listens to) from the small JSON in snippets/fb-pdp-data, instead of the
      theme fetching the whole section. A bubbling 'change' is dispatched on the form's id input (with a re-entrancy flag)
      so Appstle sees the new size. The gallery moves to the size's image when it changes; only if that image is not in
      the gallery is the section fetched (AbortController, src/srcset swap only). Any failure falls back to the theme.
   2. Interval preselect from total kg (bag kg x quantity), rounded down to the nearest plan: under 4 kg 3 weeks, under
      10 kg 4 weeks, under 20 kg 6 weeks, else 2 months (P28a table 1, provisional). Dry food only. Engangskøb stays the
      default; re-evaluated on size/quantity changes until the customer touches the interval menu.
   3. Savings in kroner while Abonnement is chosen: 'Abonnement 399 kr (spar 21 kr pr. levering)' in the fixes 58 ::before line
      (data-fb-save) and the yearly saving and the no-binding line in the ::after line (data-fb-after;
      the yearly figure only from 50 kr). Split over the two existing lines so the buttons do not move.
   4. Soft warnings: more than 0.6 kg a day, or an interval more than 2x what the calculator's g/day says a delivery lasts.
   Every Appstle selector is guarded: if the widget's markup differs, these parts silently do nothing.
   Claude v86 (Foderberegner r4, T1 – live issue L1/L2): the interval is no longer picked from the bag's kg (the band rule
   <4 kg 3 uger … 2 md. picked by the BAG, not the dog, and ran dogs out of food). It comes from the calculator's own rule:
   fbfcCore.fitPlan([this size × quantity], plans, g/day) – only when the calculator saved a g/day FOR THIS product
   (localStorage fbfc2:gpd with h = the handle). On 'fit' that plan is preselected; otherwise nothing is preselected.
   The savings use fbfcCore.saving (cash basis, floor10 – never rounded up). The old "stop any time" wording is gone; the no-binding line is the
   calculator's STOP_TXT (only when every plan has MIN_CYCLES=NULL). */
(function () {
  if (window.fbPdpSub) return; window.fbPdpSub = true;
  var dataEl = document.getElementById('fbPdpData'); if (!dataEl) return;
  var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!D || !D.v || !D.v.length) return;
  var detail = document.querySelector('.yv-main-product-detail'); if (!detail) return;
  var pi = detail.closest('product-info');
  var sid = pi ? (pi.getAttribute('data-original-section') || pi.getAttribute('data-section') || pi.getAttribute('data-section-id')) : '';
  function form() { return (sid && document.getElementById('product-form-' + sid)) || detail.querySelector('form.main-product-form'); }
  function idInput() { var f = form(); return f && f.querySelector('input[name="id"]'); }
  function byId(id) { id = String(id); for (var i = 0; i < D.v.length; i++) if (String(D.v[i].id) === id) return D.v[i]; return null; }
  function cur() { var i = idInput(); return i ? byId(i.value) : null; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function kr(c) { return String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr'; }
  function num1(x) { return (Math.round(x * 10) / 10).toString().replace('.', ','); }

  /* ---------- 1. instant size switch ---------- */
  var busy = false, passThrough = false, curMedia = 0, imgCtl = null;
  (function () { var f = document.querySelector('.yv-product-big-slider .yv-product-image-item'); if (f && f.id) curMedia = +f.id.replace('media-main-', '') || 0; })();

  function setPrice(box, v, withSize) {
    if (!box) return;
    var p = box.querySelector('[data-product-price]');
    if (p) {
      var hadSize = !!p.querySelector('.fb-psize');
      p.innerHTML = (hadSize && withSize ? '<span class="fb-psize">' + esc(v.l) + ' · </span>' : '') + esc(v.pf);
    }
    var cmp = box.querySelector('.yv-compare-price-box');
    if (cmp) cmp.innerHTML = v.cf ? '<span class="yv-product-compare-price" data-product-compare-price> ' + esc(v.cf) + '</span>' : '';
    var u = box.querySelector('.yv-product-unit-price');
    if (u) { u.textContent = v.u || ''; u.style.display = v.u ? '' : 'none'; }
  }
  function setBtn(btn, v) {
    if (!btn) return;
    var terms = detail.querySelector('[data-terms-conditions-wrapper] input[type="checkbox"]');
    var off = !v.a || (terms && !terms.checked);
    if (off) btn.setAttribute('disabled', 'disabled'); else btn.removeAttribute('disabled');
    var w = btn.closest('[data-button-wrapper]'); if (w) w.classList.toggle('disabled', !!off);
    var t = btn.querySelector('[data-button-text]');
    if (t) { var txt = !v.a ? window.soldOutText : (v.pre ? window.preorderText : window.addToCartText); if (txt) t.textContent = txt; }
  }
  function showMedia(v) {
    if (!v.m || v.m === curMedia) return;
    var el = pi && pi.querySelector('#media-main-' + v.m);
    if (el) {
      curMedia = v.m;
      var parent = el.parentElement, slider = pi.querySelector('[data-product-slider-main-wrapper]');
      if (window.innerWidth > 767 && slider && slider.classList.contains('flickity-enabled') && window.Flickity && window.Flickity.data) {
        var fl = window.Flickity.data(slider); if (fl) fl.select(Array.prototype.indexOf.call(parent.children, el));
      } else if (parent) {
        var dx = el.getBoundingClientRect().left - parent.getBoundingClientRect().left;
        if (dx) { try { parent.scrollBy({ left: dx, behavior: 'smooth' }); } catch (e) { parent.scrollLeft += dx; } }
      }
      return;
    }
    /* the size's image is not in the gallery: fetch the section once for it and swap src/srcset of the first image */
    if (!pi || !sid) return;
    try { if (imgCtl) imgCtl.abort(); } catch (e) {}
    imgCtl = window.AbortController ? new AbortController() : null;
    var url = (pi.getAttribute('data-url') || location.pathname) + '?variant=' + v.id + '&section_id=' + encodeURIComponent(sid);
    fetch(url, imgCtl ? { signal: imgCtl.signal } : {}).then(function (r) { return r.text(); }).then(function (h) {
      var doc = new DOMParser().parseFromString(h, 'text/html');
      var src = doc.querySelector('#media-main-' + v.m + ' img') || doc.querySelector('.yv-product-big-slider .yv-product-image-item img');
      var dst = pi.querySelector('.yv-product-big-slider .yv-product-image-item img');
      if (!src || !dst) return;
      ['src', 'srcset', 'sizes'].forEach(function (a) { var x = src.getAttribute(a); if (x) dst.setAttribute(a, x); });
      var s1 = src.parentNode && src.parentNode.tagName === 'PICTURE' && src.parentNode.querySelector('source');
      var s2 = dst.parentNode && dst.parentNode.tagName === 'PICTURE' && dst.parentNode.querySelector('source');
      if (s1 && s2) s2.setAttribute('srcset', s1.getAttribute('srcset'));
      curMedia = v.m;
    }).catch(function () {});
  }
  function apply(v, vs) {
    busy = true;
    try {
      vs.querySelectorAll('input.productOption').forEach(function (inp) {
        var o = inp.parentNode && inp.parentNode.querySelector('.option'); if (o) o.classList.toggle('selected', inp.checked);
      });
      var forms = sid ? document.querySelectorAll('form[id="product-form-' + sid + '"]') : [form()];
      Array.prototype.forEach.call(forms, function (f) { var i = f && f.querySelector('input[name="id"]'); if (i) { i.value = v.id; i.removeAttribute('disabled'); } });
      document.querySelectorAll('#yvProductStickyBar select[data-name^="option-"]').forEach(function (s, ix) {
        if (v.o[ix] == null) return; s.value = v.o[ix];
        Array.prototype.forEach.call(s.options, function (o) { if (o.value === v.o[ix]) o.setAttribute('selected', ''); else o.removeAttribute('selected'); });
      });
      setPrice(detail.querySelector('[data-price-main]'), v, true);
      setPrice(sid && document.getElementById('sticky-price-wrapper-' + sid), v, false);
      setBtn(form() && form().querySelector('.add_to_cart[type="submit"]'), v);
      setBtn(document.querySelector('#yvProductStickyBar .Sd_addProductSticky'), v);
      if (!pi || pi.getAttribute('data-update-url') !== 'false') {
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) {}
      }
      var id = idInput(); if (id) id.dispatchEvent(new Event('change', { bubbles: true }));
      vs.dispatchEvent(new CustomEvent('variant-change', { bubbles: true, detail: { selectedOptionLabels: v.o } }));
    } finally { busy = false; }
    document.dispatchEvent(new CustomEvent('fb:variant', { detail: { id: v.id } }));
    try { showMedia(v); } catch (e) {}
    sub.onVariant(v);
  }
  document.addEventListener('change', function (e) {
    if (busy || passThrough) return;
    var t = e.target;
    if (!t || !t.matches || !t.matches('input.productOption[type="radio"]')) return;
    var vs = t.closest('variant-selects'); if (!vs || !detail.contains(vs)) return;
    var vals = Array.prototype.map.call(vs.querySelectorAll('fieldset'), function (fs) { var c = fs.querySelector('input.productOption:checked'); return c ? c.value : null; });
    if (!vals.length || vals.indexOf(null) > -1) return;
    var v = null;
    for (var i = 0; i < D.v.length; i++) { var o = D.v[i].o; if (o.length === vals.length && o.every(function (x, k) { return x === vals[k]; })) { v = D.v[i]; break; } }
    if (!v) return; /* unknown combination: the theme handles it */
    e.stopPropagation();
    try { apply(v, vs); } catch (err) {
      busy = false; passThrough = true; /* fall back to the theme's own section fetch */
      try { t.dispatchEvent(new Event('change', { bubbles: true })); } finally { passThrough = false; }
    }
  }, true);

  /* ---------- 2-4. subscription helpers (Appstle) ---------- */
  var sub = (function () {
    var touched = false, prog = false, tries = {}, warnEl = null, raf = 0;
    var plans = (D.pl || []).map(function (p) {
      var m = String(p.n).match(/(\d+)?\.?\s*(uge|måned|maaned|dag)/i); if (!m) return null;
      var k = m[1] ? +m[1] : 1, u = m[2].toLowerCase();
      return { id: String(p.id), n: p.n, days: k * (u === 'uge' ? 7 : u === 'dag' ? 1 : 30.4) };
    }).filter(Boolean);
    function plan(id) { id = String(id || ''); for (var i = 0; i < plans.length; i++) if (plans[i].id === id || id.slice(-plans[i].id.length) === plans[i].id) return plans[i]; return null; }
    function widget() { return detail.querySelector('[id^="appstle_subscription_widget"]'); }
    function block() { var w = widget(); return w && (w.closest('.shopify-app-block') || w.parentNode); }
    function select() { var w = widget(); return w && (w.querySelector('select.appstle_select') || w.querySelector('.appstle_subscribe_option select') || w.querySelector('select')); }
    function spInput() { var f = form(); return f && f.querySelector('input[name="selling_plan"]'); }
    function aboOn() {
      var sp = spInput(); if (sp && sp.value) return true;
      var w = widget(), one = w && w.querySelector('.appstle_one_time_details_wrapper input');
      return !!(one && !one.checked);
    }
    function qty() { var q = detail.querySelector('input[name="quantity"]'); var n = q ? parseInt(q.value, 10) : 1; return n > 0 ? n : 1; }
    /* v86 (T1): the calculator's fit rule for exactly this size × quantity, or null (no preselect) */
    // the page's own food: the calculator whose sizes are this product's variants (a swapped "foreign" calculator never counts)
    function handle() {
      var ids = (D.v || []).map(function (x) { return String(x.id); }), own = '';
      Array.prototype.forEach.call(document.querySelectorAll('[data-fbfc]'), function (r) {
        if (own) return; var sz = r.querySelector('[data-fbfc-size]'), de = r.querySelector('[data-fbfc-data]');
        if (sz && ids.indexOf(String(sz.getAttribute('data-id'))) > -1 && de) { try { own = JSON.parse(de.textContent).handle || ''; } catch (e) {} }
      });
      if (own) return own;
      var m = location.pathname.match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : '';
    }
    function calcPlans() { // the calculator's plan list on this page carries Appstle's option value (opt); else the names only
      var el = document.querySelector('[data-fbfc] [data-fbfc-data]'), j = null; try { j = el ? JSON.parse(el.textContent) : null; } catch (e) { j = null; }
      var byId = {}; ((j && j.plans) || []).forEach(function (p) { byId[String(p.id)] = p; });
      return (D.pl || []).map(function (p) { var c = byId[String(p.id)] || {}; return { id: p.id, name: p.n, opt: c.opt || '', pct: +c.pct || 0 }; });
    }
    function shipCfg() { var el = document.querySelector('[data-fbfc-ship]'); try { var j = el && JSON.parse(el.getAttribute('data-fbfc-ship')); if (j && isFinite(+j.min)) return { min: +j.min, fee: +j.fee }; } catch (e) {} return { min: 49900, fee: 3900 }; }
    function pct(v) { return v.ap && v.ap < v.p ? Math.round((1 - v.ap / v.p) * 100) : 0; }
    function sizeOf(v) { var n = (/^\s*(\d+)\s*[x×]/i.exec(String(v.l || '')) || [0, 1])[1], q = qty(); return { id: v.id, grams: v.kg * 1000 * q, price: v.p * q, available: true, title: v.l, n: +n * q, plans: (v.ps || []).map(String) }; }
    function target(v) {
      var C = window.fbfcCore, g = gpd();
      if (!C || !C.fitPlan || !D.iv || !v || !v.kg || !v.ps || !v.ps.length || !g) return null;
      var pls = calcPlans().map(function (p) { if (!p.pct) p.pct = pct(v); return p; });
      var F = C.fitPlan([sizeOf(v)], pls, g, { ship: shipCfg(), maxQ: 1 });
      return F && F.status === 'fit' && F.fit ? plan(F.fit.plan.id) : null;
    }
    function optFor(sel, p) {
      var os = sel.options;
      for (var i = 0; i < os.length; i++) if (os[i].value === p.id || (os[i].value && os[i].value.slice(-p.id.length) === p.id)) return os[i];
      var n = p.n.toLowerCase();
      for (var j = 0; j < os.length; j++) { var t = (os[j].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase(); if (t === n || t.indexOf(n + ' ') === 0 || t.indexOf(n + '(') === 0) return os[j]; }
      return null;
    }
    function setSel(sel, opt, fire) {
      if (sel.value === opt.value) return false;
      prog = true;
      try { sel.value = opt.value; if (fire) sel.dispatchEvent(new Event('change', { bubbles: true })); } finally { prog = false; }
      return true;
    }
    /* chosen plan: the form's selling_plan, else the menu */
    function chosen() { var sp = spInput(); var p = sp && sp.value ? plan(sp.value) : null; if (!p) { var s = select(); p = s ? plan(s.value) : null; } return p; }
    function preselect() {
      var v = cur(), sel = select(); if (!v || !sel) return;
      var on = aboOn(), sp = spInput();
      /* the plan must belong to the chosen size */
      if (on && sp && sp.value && v.ps && v.ps.length && !v.ps.some(function (x) { return String(x) === String(sp.value) || String(sp.value).slice(-String(x).length) === String(x); })) {
        var t0 = target(v) || plan(v.ps[0]); var o0 = t0 && optFor(sel, t0);
        if (o0) setSel(sel, o0, true);
        else { var one = widget() && widget().querySelector('.appstle_one_time_details_wrapper input'); if (one && !one.checked) one.click(); }
        return;
      }
      if (touched) return;
      var t = target(v); if (!t) return;
      var o = optFor(sel, t); if (!o) return;
      /* while Engangskøb is chosen only the menu's value is set (no change event, so Appstle does not switch to Abonnement) */
      setSel(sel, o, on);
      if (on && sp && sp.value && plan(sp.value) && plan(sp.value).id !== t.id) {
        var key = v.id + ':' + t.id; tries[key] = (tries[key] || 0) + 1;
        if (tries[key] <= 2) { prog = true; try { sel.dispatchEvent(new Event('change', { bubbles: true })); } finally { prog = false; } }
      }
    }
    function savings() {
      var b = block(), v = cur(); if (!b) return;
      var txt = '', yr = '', C = window.fbfcCore;
      if (v && v.ap && v.ap < v.p && aboOn()) {
        var q = qty(), full = v.p * q, sub = v.ap * q, p = chosen() || target(v), days = p ? p.days : 0, g = gpd();
        var L = g ? v.kg * 1000 * q / g : days; // pack days at the calculator's g/day; without it the plan's own days
        var sv = C && C.saving && days ? C.saving(full, sub, L, days, shipCfg()) : null, net = sv ? sv.net : full - sub;
        if (net > 0) txt = 'Fast levering ' + kr(sub) + ' (spar ' + kr(net) + ' pr. levering)';
        var st = C && C.stopTxt ? C.stopTxt(calcPlans()) : '';
        if (sv && sv.yearly) yr = 'ca. ' + sv.yearly + ' kr. om året' + (st ? ' · ' + st : ''); // fbfcCore: cash basis, floor10, >= 100 kr.
        else if (st) yr = st;
      }
      /* line 1 (the fixes 58 ::before line) and line 2 (the ::after "Ingen binding" line), so no extra row */
      [['data-fb-save', txt], ['data-fb-after', yr]].forEach(function (a) {
        if (a[1]) { if (b.getAttribute(a[0]) !== a[1]) b.setAttribute(a[0], a[1]); } else if (b.hasAttribute(a[0])) b.removeAttribute(a[0]);
      });
    }
    function gpd() { // v86 (T1): only a g/day the calculator saved for THIS product counts
      try { var g = JSON.parse(localStorage.getItem('fbfc2:gpd') || 'null'); if (g && g.g > 0 && g.h && g.h === handle()) return g.g; } catch (e) {}
      return 0;
    }
    function warn() {
      var b = block(), v = cur(); if (!b) return;
      var msg = '';
      if (D.iv && v && v.kg && aboOn()) {
        var p = chosen();
        if (p) {
          var kg = v.kg * qty(), perDay = kg / p.days, kgTxt = num1(kg) + ' kg', every = p.n.charAt(0).toLowerCase() + p.n.slice(1);
          var who = D.sp === 'kat' ? 'katte' : 'hunde';
          if (perDay > 0.6) msg = 'Obs: ' + kgTxt + ' ' + every + ' er ca. ' + num1(perDay) + ' kg om dagen. Det er mere, end de fleste ' + who + ' spiser, så vælg gerne et længere interval.';
          else { var g = gpd(); if (g) { var lasts = kg * 1000 / g; if (p.days > 2 * lasts) msg = 'Obs: Med ca. ' + Math.round(g) + ' g om dagen (din foderberegning) holder ' + kgTxt + ' ca. ' + Math.round(lasts) + ' dage, så maden slipper op længe før næste levering ' + every + '.'; } }
        }
      }
      if (!warnEl) { if (!msg) return; warnEl = document.createElement('p'); warnEl.className = 'fb-sub-warn'; warnEl.setAttribute('role', 'status'); }
      if (msg && (warnEl.parentNode !== b.parentNode || warnEl.previousSibling !== b)) b.parentNode.insertBefore(warnEl, b.nextSibling);
      if (warnEl.textContent !== msg) warnEl.textContent = msg;
      warnEl.hidden = !msg;
    }
    function tick() {
      try { preselect(); savings(); warn(); } catch (e) {}
    }
    function soon() { if (raf) return; raf = (window.requestAnimationFrame || setTimeout)(function () { raf = 0; tick(); }); }
    /* the customer touches the interval menu: stop re-evaluating */
    function mark(e) {
      if (prog || !e.isTrusted) return;
      var w = widget(); if (!w || !w.contains(e.target)) return;
      if (e.target.closest('select, .appstleRadioSellingPlanWrapper')) touched = true;
    }
    ['pointerdown', 'keydown', 'change'].forEach(function (ev) { detail.addEventListener(ev, mark, true); });
    detail.addEventListener('change', function () { soon(); });
    detail.addEventListener('input', function () { soon(); });
    detail.addEventListener('click', function () { setTimeout(tick, 60); });
    if (window.MutationObserver) new MutationObserver(soon).observe(detail, { childList: true, subtree: true });
    setInterval(tick, 500);
    tick();
    return { onVariant: function () { setTimeout(tick, 0); setTimeout(tick, 300); } };
  })();
})();
